import { css, styled, useTheme } from '@core-ui/react-stitch';
import { StyledButtonProps } from '../../../types/buttonVariant';
import { getDefaultStyles } from './helpers/getDefaultStyles';
import { getModalStyles } from './helpers/getModalStyles';

const StyledButton = styled.button<StyledButtonProps>(
  ({ theme = useTheme(), isXLarge, variant = 'default' }) => {
    const brandStyles =
      variant !== 'modal'
        ? getDefaultStyles({ theme, isXLarge })
        : getModalStyles({ theme });

    return css`
    ${brandStyles}
  `;
  }
);

const StyledDiv = styled.div`
  margin-left: auto;
`;

export {
  StyledButton,
  StyledDiv
};
